import { useTranslation } from "react-i18next";
import "./status-turma.css";
import useStatusTurma from "./useStatusTurma";

interface StatusTurmaProps {
  dataInicio: Date;
  dataFim: Date;
}

export default function StatusTurma({ dataInicio, dataFim }: StatusTurmaProps) {
  const { dotColor, statusText } = useStatusTurma({ dataInicio, dataFim });
  const { t } = useTranslation(['gestao_de_aulas']);

  return (
    <div className="status-turma">
      <div className={dotColor}></div>
      <p className={statusText === t('gestao_de_aulas:inProgress') ? 'ativo' : 'inativo'}>
        {statusText}
      </p>
    </div>
  );
}
